import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { CircularProgress, Modal, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useMutation } from "@tanstack/react-query";
import { userApi } from "api/user/user";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { BtnStyle } from "styles/buttonStyle";
import { snackBarStyle } from "styles/snackBarStyle";
import { textFieldStyles } from "styles/textFieldStyles";
import * as Yup from "yup";

const ForgetPassword = ({ display, onClose, backToLogin }) => {
  const { enqueueSnackbar } = useSnackbar();

  const Mutation = useMutation({
    mutationFn: userApi.resetRequest,
    mutationKey: "users",
    onSuccess: (response) => {
      if (response.status === 200) {
        enqueueSnackbar("Der er sendt en e-mail", snackBarStyle());
        formik.resetForm();
      } else {
        enqueueSnackbar("error", snackBarStyle("error"));
      }
    },
    onError: (error) => {
      enqueueSnackbar("Something went wrong !!", snackBarStyle("error"));
    },
  });
  // Form Validation
  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
  });
  // Form Handler
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      Mutation.mutate(values);
    },
  });

  return (
    <Modal open={display}>
      <Box
        component="main"
        sx={{
          height: "100vh",
          width: 1,
          position: "fixed",
          top: 0,
          left: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component={"div"}
          onClick={onClose}
          sx={{
            height: "100vh",
            width: 1,
            position: "fixed",
            top: 0,
            left: 0,
            bgcolor: "black",
            zIndex: -10,
            opacity: "0",
          }}
        ></Box>
        <Box
          component={"div"}
          sx={{
            bgcolor: "white",
            p: { xs: 3, sm: 4 },
            width: { xs: "80%", sm: "440px" },
            maxWidth: "440px",
          }}
        >
          <Typography variant="h6" component="h2">
            Glemt dit kodeord
          </Typography>
          <Typography component="p" mt={2} mb={2}>
            Skriv din e-mail og vi sender dig et link hvor du kan lave et nyt
            kodeord.
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={formik.handleSubmit}
            sx={{
              mt: 1,
              width: 1,
            }}
          >
            <Box mb={2} position={"relative"}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                type="text"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                sx={textFieldStyles}
              />
              {formik.touched.email && Boolean(formik.errors.email) && (
                <Typography
                  component={"p"}
                  mt={0.5}
                  position={"absolut"}
                  fontSize={12}
                  color={"error"}
                >
                  {formik.errors.email}
                </Typography>
              )}
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 2,
                mb: 2,
                height: "50px",
                bgcolor: "#424242",
                "&:hover": {
                  bgcolor: "#686868",
                },
              }}
            >
              {Mutation.isPending ? (
                <CircularProgress sx={{ color: "white" }} size={"25px"} />
              ) : (
                "SEND"
              )}
            </Button>
            <Box sx={{ textAlign: "center", alignContent: "center" }}>
              <Button sx={BtnStyle} onClick={backToLogin}>
                {" "}
                <ArrowBackIosIcon fontSize="" />
                Tilbage
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ForgetPassword;
